var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoTasksFound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 261,
    height: 296,
    viewBox: "0 0 261 296",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1660_87)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1660_87",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 261,
    height: 296
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M261 0H0V295.418H261V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1660_87)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M184.103 278.927C192.388 271.117 196.661 259.416 192.21 249.518C185.73 259.478 175.062 267.322 162.695 271.221C157.877 272.739 152.338 273.993 149.717 277.823C148.087 280.206 147.969 283.192 148.703 285.891C149.437 288.59 150.95 291.073 152.448 293.521L152.456 294.213C164.18 291.226 175.818 286.738 184.103 278.927Z",
    fill: "url(#paint0_linear_1660_87)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M191.962 249.57C190.565 258.19 185.994 266.477 179.004 272.723C177.487 274.136 175.766 275.312 173.898 276.21C171.976 277.063 169.881 277.451 167.781 277.342C165.803 277.279 163.789 277.016 161.828 277.372C160.866 277.541 159.948 277.903 159.13 278.436C158.311 278.968 157.608 279.66 157.062 280.472C155.763 282.386 155.331 284.594 154.995 286.764C154.622 289.174 154.278 291.683 152.694 293.756C152.502 294.008 152.961 294.253 153.153 294.001C155.91 290.394 154.988 285.784 156.848 281.894C157.716 280.078 159.218 278.48 161.464 277.931C163.428 277.452 165.505 277.723 167.507 277.801C169.559 277.932 171.614 277.62 173.535 276.889C175.449 276.077 177.218 274.962 178.777 273.585C182.189 270.666 185.104 267.21 187.409 263.354C189.966 259.129 191.695 254.454 192.5 249.58C192.549 249.282 192.009 249.274 191.962 249.57Z",
    fill: "url(#paint1_linear_1660_87)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M181.398 270.797C182.82 271.68 184.483 272.097 186.154 271.99C187.824 271.884 189.421 271.258 190.719 270.2C190.966 269.988 190.598 269.646 190.352 269.858C189.144 270.845 187.658 271.427 186.103 271.524C184.547 271.621 183 271.226 181.68 270.397C181.401 270.219 181.121 270.619 181.398 270.797Z",
    fill: "url(#paint2_linear_1660_87)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M168.779 277.488C168.502 275.984 168.547 274.436 168.91 272.949C169.274 271.461 169.948 270.068 170.888 268.861C171.079 268.609 170.619 268.365 170.429 268.616C169.453 269.874 168.755 271.326 168.381 272.873C168.006 274.422 167.963 276.032 168.256 277.598C168.313 277.896 168.836 277.785 168.779 277.488Z",
    fill: "url(#paint3_linear_1660_87)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M189.282 259.004C188.695 258.794 188.171 258.438 187.76 257.968C187.348 257.498 187.064 256.931 186.933 256.321C186.88 256.022 186.357 256.134 186.409 256.43C186.558 257.104 186.872 257.73 187.325 258.249C187.779 258.769 188.354 259.166 189.001 259.404C189.062 259.434 189.132 259.443 189.2 259.429C189.267 259.415 189.327 259.379 189.371 259.326C189.389 259.299 189.402 259.27 189.407 259.238C189.412 259.207 189.41 259.175 189.402 259.145C189.393 259.114 189.378 259.085 189.358 259.06C189.337 259.037 189.312 259.017 189.282 259.004Z",
    fill: "url(#paint4_linear_1660_87)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M152.92 238.262C152.948 238.449 152.975 238.636 152.999 238.826C153.348 241.339 153.461 243.879 153.338 246.414C153.332 246.61 153.323 246.809 153.31 247.004C152.92 253.17 151.241 259.186 148.384 264.661C147.221 266.896 145.879 269.033 144.37 271.05C142.267 273.866 139.73 276.772 138.844 279.934C138.749 280.261 138.675 280.595 138.626 280.933L151.484 294.166C151.531 294.184 151.574 294.204 151.621 294.222L152.107 294.771C152.194 294.67 152.282 294.564 152.369 294.464C152.419 294.405 152.467 294.345 152.518 294.287C152.55 294.247 152.584 294.207 152.615 294.173C152.627 294.16 152.637 294.147 152.645 294.136C152.677 294.102 152.703 294.067 152.732 294.035C153.224 293.446 153.713 292.853 154.197 292.254C154.2 292.252 154.2 292.252 154.2 292.247C157.877 287.683 161.149 282.814 163.467 277.667C163.537 277.512 163.61 277.354 163.674 277.194C164.698 274.887 165.509 272.49 166.096 270.034C166.408 268.701 166.643 267.35 166.801 265.99C167.198 262.477 166.957 258.923 166.09 255.496C164.358 248.632 160.123 242.325 153.435 238.547C153.263 238.45 153.095 238.356 152.92 238.262Z",
    fill: "url(#paint5_linear_1660_87)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M152.758 238.436C157.608 246.05 159.693 255.06 158.435 263.71C158.208 265.613 157.645 267.461 156.771 269.168C155.8 270.883 154.383 272.303 152.671 273.276C151.048 274.262 149.257 275.106 147.938 276.417C147.289 277.056 146.8 277.84 146.512 278.703C146.224 279.568 146.144 280.488 146.278 281.389C146.565 283.598 147.748 285.587 148.982 287.496C150.352 289.616 151.814 291.799 151.983 294.284C152.004 294.585 152.54 294.54 152.519 294.24C152.224 289.915 148.298 286.717 147.09 282.637C146.527 280.733 146.621 278.669 148.034 277.055C149.27 275.644 151.116 274.772 152.769 273.786C154.458 272.852 155.894 271.518 156.951 269.9C157.919 268.242 158.564 266.415 158.849 264.517C159.552 260.31 159.488 256.011 158.661 251.826C157.72 246.966 155.866 242.328 153.194 238.161C153.027 237.898 152.591 238.174 152.758 238.436Z",
    fill: "url(#paint6_linear_1660_87)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M159.014 260.917C162.536 260.885 165.54 258.586 166.044 255.559C166.094 255.26 165.563 255.179 165.514 255.477C165.042 258.314 162.254 260.42 158.963 260.451C158.616 260.454 158.669 260.92 159.014 260.917Z",
    fill: "url(#paint7_linear_1660_87)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M153.568 272.87C152.35 271.899 151.343 270.689 150.606 269.315C149.869 267.941 149.418 266.431 149.282 264.877C149.26 264.576 148.724 264.622 148.745 264.922C148.892 266.539 149.364 268.109 150.134 269.538C150.904 270.966 151.957 272.223 153.226 273.232C153.479 273.44 153.82 273.077 153.568 272.87Z",
    fill: "url(#paint8_linear_1660_87)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M157.146 247.369C156.496 247.501 155.824 247.489 155.178 247.331C154.533 247.173 153.931 246.875 153.414 246.458C153.165 246.248 152.824 246.61 153.071 246.819C153.644 247.278 154.31 247.606 155.023 247.782C155.736 247.958 156.478 247.976 157.198 247.836C157.341 247.808 157.454 247.717 157.44 247.58C157.427 247.513 157.39 247.455 157.335 247.416C157.281 247.377 157.213 247.36 157.146 247.369Z",
    fill: "url(#paint9_linear_1660_87)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.932 247.502C99.9277 258.46 84.0157 261.241 71.1269 255.333C54.587 247.751 44.5677 226.878 43.6382 198.064L44.618 198.155C45.5344 226.568 55.3167 247.107 71.4565 254.505C83.9997 260.254 99.5682 257.491 115.294 246.723L115.932 247.502Z",
    fill: "url(#paint10_linear_1660_87)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.831 61.9626C213.255 79.3518 208.766 97.6876 201.724 115.379C193.016 137.258 181.119 156.528 167.319 171.107L166.553 170.439C180.286 155.93 192.13 136.745 200.801 114.957C208.638 95.2674 213.299 74.7778 214.287 55.7119L215.266 55.8761C215.162 57.8896 215.017 59.9185 214.831 61.9626Z",
    fill: "url(#paint11_linear_1660_87)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.107 182.58C205.723 213.462 182.208 235.526 158.89 244.71L158.417 243.844C181.574 234.724 204.953 212.771 224.248 182.031L225.107 182.58Z",
    fill: "url(#paint12_linear_1660_87)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.015 113.389C254.695 116.914 254.286 120.481 253.787 124.092L252.814 123.856C256.545 96.9113 255.222 72.2065 248.986 52.407L249.923 52.25C255.361 69.5216 257.091 90.4852 255.015 113.389Z",
    fill: "url(#paint13_linear_1660_87)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5601 86.6209C50.0721 91.8696 47.7057 97.3071 45.5264 102.782C32.9855 134.292 26.6304 166.471 27.1497 195.843L26.1696 195.738C25.6497 166.257 32.0232 133.967 44.6033 102.36C46.7888 96.8683 49.1621 91.4158 51.6571 86.1523L52.5601 86.6209Z",
    fill: "url(#paint14_linear_1660_87)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.461 269.153C99.4571 280.11 83.545 282.891 70.6562 276.984C54.1163 269.403 44.097 248.528 43.1675 219.714L44.1473 219.807C45.0637 248.22 54.846 268.757 70.9858 276.156C83.5291 281.906 99.0977 279.142 114.824 268.375L115.461 269.153Z",
    fill: "url(#paint15_linear_1660_87)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.838 211.838C204.454 242.719 180.938 264.785 157.62 273.969L157.148 273.103C180.305 263.982 203.684 242.03 222.979 211.29L223.838 211.838Z",
    fill: "url(#paint16_linear_1660_87)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.543 135.04C254.224 138.564 253.815 142.132 253.316 145.742L252.344 145.506C256.074 118.562 254.751 93.8574 248.515 74.058L249.452 73.9009C254.89 91.1724 256.62 112.136 254.543 135.04Z",
    fill: "url(#paint17_linear_1660_87)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0894 108.27C49.6015 113.519 47.235 118.957 45.0557 124.432C32.5148 155.941 26.1597 188.12 26.679 217.492L25.6989 217.387C25.179 187.906 31.5524 155.616 44.1325 124.009C46.3182 118.518 48.6914 113.065 51.1865 107.802L52.0894 108.27Z",
    fill: "url(#paint18_linear_1660_87)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.596 93.0771C240.68 91.4463 240.038 89.1118 238.163 87.8628C236.289 86.614 233.891 86.9235 232.808 88.5543C231.724 90.1853 232.365 92.5198 234.24 93.7687C236.115 95.0176 238.512 94.708 239.596 93.0771Z",
    fill: "url(#paint19_linear_1660_87)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8987 219.179C60.9819 217.548 60.3404 215.213 58.4656 213.964C56.5917 212.715 54.193 213.025 53.1098 214.656C52.0266 216.287 52.6672 218.621 54.542 219.87C56.4168 221.119 58.8145 220.81 59.8987 219.179Z",
    fill: "url(#paint20_linear_1660_87)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.06 113.867C117.329 110.386 121.032 107.65 125.158 107.418C129.284 107.187 134.241 110.705 136.277 114.326C140.002 120.947 138.385 127.314 133.256 131.92C132.559 131.683 130.127 130.968 129.419 130.74L128.969 129.927L128.416 130.422C122.076 131.054 115.953 130.349 111.181 125.618C111.774 121.503 112.791 117.349 115.06 113.867Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.057 160.345L131.308 167.305L131.749 176.433L111.56 174.031L109.663 160.345L112.08 160.369L132.057 160.345Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.767 130.266C128.397 130.266 132.151 126.508 132.151 121.871C132.151 117.235 128.397 113.476 123.767 113.476C119.137 113.476 115.384 117.235 115.384 121.871C115.384 126.508 119.137 130.266 123.767 130.266Z",
    fill: "#FFB7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.764 138.905L119.569 135.111L129.178 133.846L137.67 139.537L137.585 156.923L132.198 174.956L109.617 171.162L108.759 164.802C108.759 164.802 102.514 153.762 109.24 147.44L114.764 138.905Z",
    fill: "#3E6E9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.632 109.121C122.449 108.611 124.369 108.599 126.192 109.087C128.014 109.574 129.673 110.543 130.993 111.892C132.314 113.241 133.248 114.92 133.7 116.755C134.15 118.589 134.1 120.511 133.555 122.32C128.45 122.727 123.403 122.25 119.425 118.633L119.07 115.53L117.619 118.127C116.155 117.714 114.689 117.299 113.22 116.881C113.67 115.051 114.59 113.372 115.891 112.01C117.192 110.648 118.826 109.652 120.632 109.121Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6868 98.242C85.4596 98.7277 85.3412 99.2573 85.3403 99.7927C85.3394 100.329 85.4558 100.859 85.6815 101.345C85.9072 101.831 86.2365 102.262 86.6464 102.607C87.0562 102.952 87.5367 103.203 88.0538 103.342L103.673 132.854L109.977 127.981L92.6418 100.503C92.8172 99.6177 92.6621 98.699 92.2061 97.9208C91.75 97.1416 91.0246 96.5584 90.1673 96.2792C89.3101 96.001 88.3805 96.046 87.5547 96.4083C86.7289 96.7697 86.0642 97.4227 85.6868 98.242Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.985 145.351C112.985 145.351 111.538 146.636 109.48 143.087C107.832 140.245 99.6136 127.521 98.4501 123.11C97.8125 123.128 97.1863 122.933 96.6709 122.555C96.1556 122.178 95.7799 121.639 95.604 121.025L104.431 117.593C106.35 118.554 105.817 119.886 105.331 120.575L108.619 125.513L119.554 137.802L114.048 144.44L112.985 145.351Z",
    fill: "#3E6E9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.524 295.417H0.476141C0.34986 295.417 0.228747 295.367 0.139452 295.277C0.050158 295.188 0 295.067 0 294.94C0 294.813 0.050158 294.693 0.139452 294.603C0.228747 294.514 0.34986 294.463 0.476141 294.463H260.524C260.65 294.463 260.772 294.514 260.86 294.603C260.95 294.693 261 294.813 261 294.94C261 295.067 260.95 295.188 260.86 295.277C260.772 295.367 260.65 295.417 260.524 295.417Z",
    fill: "#CCCCCC",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M198.268 29.3053C193.574 24.6725 187.307 22.1156 181.021 20.4798C173.907 18.628 166.549 17.5373 159.28 16.4908C151.705 15.4001 144.1 14.5589 136.465 13.9671C128.841 13.3784 121.202 13.0414 113.549 12.9561C106.73 12.8796 99.8658 12.8772 93.08 13.6348C86.6887 14.3484 80.3129 15.7803 74.5509 18.72C69.4218 21.2805 65.1127 25.2302 62.1132 30.1204C59.3555 34.6722 57.716 40.1289 58.2861 45.4795C58.5535 48.1142 59.3728 50.6629 60.6903 52.9592C62.2347 55.4967 64.2029 57.7497 66.509 59.62C71.27 63.6459 76.9622 66.5889 81.0579 71.3736C82.1395 72.6271 83.0842 73.9927 83.8761 75.4471C84.4708 76.5501 85.1398 77.4994 86.2459 78.1429C87.2333 78.7072 88.3655 78.966 89.4996 78.8869C90.6338 78.8077 91.7191 78.3941 92.6188 77.6981C93.8946 76.6953 94.8109 75.1495 95.7978 73.8772L99.2406 69.4406C99.4901 69.0428 99.7779 68.6712 100.101 68.3314C100.333 68.1393 99.9509 68.3085 100.026 68.2607C100.068 68.2344 100.142 68.249 100.187 68.2303C100.416 68.1644 100.652 68.1207 100.89 68.0997C103.403 67.6368 105.922 67.2038 108.447 66.801C117.769 65.2948 127.15 64.0523 136.571 63.3827C141.427 62.9944 146.301 62.8779 151.17 63.034C157.466 63.292 163.674 64.5438 169.947 65.0839C176.7 65.6654 183.794 65.5851 190.158 62.9773C195.251 60.89 199.981 57.3784 202.739 52.5282C204.048 50.2343 204.823 47.6744 205.007 45.039C205.343 39.0614 202.441 33.4245 198.268 29.3053Z",
    fill: "url(#paint21_linear_1660_87)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.785 18.165C108.584 18.165 107.383 18.1714 106.183 18.1841C94.6652 18.3065 82.7611 19.2391 73.7275 25.1847C65.7094 30.4622 60.0899 42.2176 64.8456 50.6481C67.0294 54.5192 70.9861 57.337 75.1751 60.3201C76.8169 61.4895 78.515 62.6987 80.1423 64.001C83.6971 66.8457 87.0445 70.6634 88.9702 74.9562L97.4287 64.0558L99.0263 63.7494C100.564 63.4548 136.901 56.5547 156.253 58.7948C158.033 59.0008 159.832 59.2379 161.572 59.4672C169.433 60.5031 176.859 61.4808 183.988 60.037C191.43 58.5288 199.602 52.773 200.089 45.0759C200.421 39.8064 196.998 34.0256 191.368 30.3487C185.674 26.631 178.573 25.096 171.788 23.8424C151.335 20.0684 130.581 18.1681 109.785 18.165Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5134 99.1656C92.6853 99.1656 96.0673 95.7793 96.0673 91.6012C96.0673 87.4234 92.6853 84.0366 88.5134 84.0366C84.3415 84.0366 80.9595 87.4234 80.9595 91.6012C80.9595 95.7793 84.3415 99.1656 88.5134 99.1656Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5345 184.625C67.6179 182.994 66.9766 180.659 65.1021 179.41C63.2275 178.161 60.8295 178.47 59.7461 180.101C58.6626 181.732 59.3039 184.067 61.1785 185.316C63.053 186.564 65.451 186.256 66.5345 184.625Z",
    fill: "url(#paint22_linear_1660_87)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.611 184.109C229.695 182.478 229.053 180.144 227.178 178.895C225.304 177.645 222.906 177.955 221.823 179.586C220.738 181.217 221.38 183.552 223.255 184.8C225.13 186.049 227.527 185.74 228.611 184.109Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.427 125.241C168.51 123.611 167.87 121.276 165.995 120.027C164.12 118.778 161.722 119.088 160.639 120.719C159.555 122.35 160.196 124.684 162.071 125.933C163.946 127.182 166.344 126.872 167.427 125.241Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.529 286.719H138.115L136.015 269.669H142.529V286.719Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.858 294.378H141.693L141.128 291.386L139.681 294.378H131.286C130.883 294.378 130.491 294.249 130.167 294.01C129.843 293.772 129.603 293.436 129.483 293.05C129.364 292.666 129.37 292.253 129.502 291.873C129.633 291.491 129.882 291.162 130.213 290.933L136.918 286.297V283.271L143.968 283.693L144.858 294.378Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.735 286.719H113.321L111.22 269.669H117.735V286.719Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.065 294.378H116.899L116.334 291.386L114.887 294.378H106.492C106.089 294.378 105.697 294.249 105.373 294.01C105.049 293.772 104.81 293.436 104.69 293.05C104.57 292.666 104.577 292.253 104.708 291.873C104.839 291.491 105.088 291.162 105.419 290.933L112.124 286.297V283.271L119.175 283.693L120.065 294.378Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.434 272.017H144.386L143.537 244.296C144.086 243.235 144.365 242.054 144.348 240.859C144.331 239.664 144.02 238.492 143.442 237.446L143.32 237.226L143.635 235.763C144.04 233.884 143.854 231.925 143.104 230.155L142.312 204.297C145.141 185.935 131.658 173.961 131.658 173.961H111.46L107.124 188.88C104.257 216.849 104.777 244.103 109.326 270.508L109.202 270.57C108.756 270.725 108.564 271.344 108.774 271.954C108.984 272.563 109.517 272.933 109.963 272.778L120.63 272.408C121.076 272.253 121.269 271.633 121.058 271.023C120.848 270.413 120.315 270.044 119.869 270.199L119.143 270.566L120.69 243.816L120.519 238.931L120.873 233.388L122.508 208.454L128.696 239.114L135.017 272.326C134.843 272.484 134.721 272.691 134.667 272.921C134.612 273.149 134.629 273.39 134.713 273.609C134.798 273.829 134.949 274.018 135.143 274.15C135.337 274.283 135.566 274.354 135.802 274.353H144.434C144.743 274.353 145.04 274.231 145.259 274.012C145.478 273.792 145.6 273.496 145.6 273.186C145.6 272.876 145.478 272.579 145.259 272.36C145.04 272.141 144.743 272.017 144.434 272.017Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.742 194.656C134.198 194.375 134.586 193.997 134.881 193.549C135.175 193.102 135.367 192.594 135.445 192.063C135.522 191.534 135.483 190.993 135.329 190.479C135.175 189.966 134.91 189.492 134.554 189.092L137.648 155.835L129.708 156.449L129.164 188.947C128.532 189.591 128.159 190.445 128.114 191.346C128.069 192.248 128.356 193.134 128.92 193.838C129.485 194.541 130.287 195.014 131.176 195.165C132.064 195.315 132.977 195.134 133.742 194.656Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.422 138.63C136.422 138.63 138.336 138.35 138.114 142.449C137.937 145.73 138.781 165.954 137.339 170.282C137.883 170.617 138.3 171.124 138.525 171.723C138.748 172.321 138.767 172.978 138.578 173.589L129.318 171.612C128.238 169.755 128.462 167.849 129.246 167.539L129.2 161.605L127.153 142.041L135.035 138.809L136.422 138.63Z",
    fill: "#3E6E9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.046 32.3213V46.13H104.665L98.4723 36.2382V46.13H96.0918V32.3213H98.4723L104.684 42.2321V32.3213H107.046Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.218 41.113V40.8949C109.218 40.1552 109.325 39.4691 109.54 38.8369C109.755 38.1983 110.065 37.6451 110.47 37.1772C110.881 36.703 111.38 36.3363 111.968 36.077C112.562 35.8115 113.233 35.6787 113.979 35.6787C114.731 35.6787 115.401 35.8115 115.989 36.077C116.584 36.3363 117.086 36.703 117.497 37.1772C117.908 37.6451 118.221 38.1983 118.436 38.8369C118.651 39.4691 118.759 40.1552 118.759 40.8949V41.113C118.759 41.8528 118.651 42.5388 118.436 43.1711C118.221 43.8033 117.908 44.3566 117.497 44.8308C117.086 45.2987 116.587 45.6654 115.999 45.9309C115.411 46.1902 114.744 46.3198 113.998 46.3198C113.245 46.3198 112.572 46.1902 111.978 45.9309C111.39 45.6654 110.89 45.2987 110.479 44.8308C110.068 44.3566 109.755 43.8033 109.54 43.1711C109.325 42.5388 109.218 41.8528 109.218 41.113ZM111.503 40.8949V41.113C111.503 41.5746 111.551 42.0109 111.646 42.4218C111.74 42.8328 111.889 43.1932 112.091 43.503C112.294 43.8128 112.553 44.0562 112.869 44.2333C113.185 44.4103 113.561 44.4988 113.998 44.4988C114.421 44.4988 114.788 44.4103 115.098 44.2333C115.414 44.0562 115.673 43.8128 115.875 43.503C116.078 43.1932 116.226 42.8328 116.321 42.4218C116.422 42.0109 116.473 41.5746 116.473 41.113V40.8949C116.473 40.4397 116.422 40.0097 116.321 39.6051C116.226 39.1941 116.075 38.8306 115.866 38.5144C115.664 38.1983 115.404 37.9517 115.088 37.7747C114.778 37.5913 114.409 37.4996 113.979 37.4996C113.549 37.4996 113.176 37.5913 112.86 37.7747C112.55 37.9517 112.294 38.1983 112.091 38.5144C111.889 38.8306 111.74 39.1941 111.646 39.6051C111.551 40.0097 111.503 40.4397 111.503 40.8949Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.965 32.3213V46.13H128.603V32.3213H130.965ZM135.299 32.3213V34.2181H124.307V32.3213H135.299Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.406 44.0721V39.1783C141.406 38.8116 141.34 38.4955 141.207 38.2299C141.074 37.9644 140.872 37.7589 140.6 37.6134C140.335 37.468 140 37.3953 139.595 37.3953C139.222 37.3953 138.899 37.4585 138.628 37.585C138.356 37.7114 138.144 37.8822 137.992 38.0971C137.84 38.3121 137.765 38.5555 137.765 38.8274H135.488C135.488 38.4227 135.586 38.0307 135.782 37.6514C135.978 37.272 136.263 36.9338 136.636 36.6366C137.009 36.3394 137.455 36.1055 137.973 35.9348C138.492 35.7641 139.073 35.6787 139.718 35.6787C140.49 35.6787 141.172 35.8083 141.767 36.0675C142.367 36.3268 142.838 36.7188 143.18 37.2436C143.528 37.762 143.702 38.4133 143.702 39.1973V43.7591C143.702 44.227 143.733 44.6474 143.796 45.0205C143.866 45.3872 143.964 45.7065 144.09 45.9783V46.1301H141.748C141.64 45.8835 141.555 45.5705 141.492 45.1912C141.435 44.8055 141.406 44.4324 141.406 44.0721ZM141.738 39.8896L141.757 41.3027H140.117C139.693 41.3027 139.32 41.3438 138.997 41.426C138.675 41.5019 138.406 41.6157 138.191 41.7674C137.976 41.9192 137.815 42.1025 137.708 42.3175C137.6 42.5325 137.546 42.7759 137.546 43.0478C137.546 43.3197 137.61 43.5694 137.736 43.797C137.863 44.0183 138.046 44.1922 138.286 44.3186C138.533 44.4451 138.83 44.5083 139.178 44.5083C139.646 44.5083 140.053 44.4135 140.401 44.2238C140.755 44.0278 141.033 43.7907 141.236 43.5125C141.438 43.228 141.545 42.9593 141.558 42.7064L142.298 43.7211C142.222 43.9804 142.092 44.2586 141.909 44.5557C141.726 44.8529 141.485 45.1374 141.188 45.4093C140.897 45.6749 140.547 45.893 140.136 46.0637C139.731 46.2344 139.263 46.3198 138.732 46.3198C138.062 46.3198 137.464 46.187 136.939 45.9214C136.415 45.6496 136.004 45.286 135.707 44.8308C135.409 44.3692 135.261 43.8476 135.261 43.2659C135.261 42.7222 135.362 42.2416 135.564 41.8243C135.773 41.4007 136.076 41.0467 136.475 40.7621C136.879 40.4776 137.373 40.2626 137.954 40.1172C138.536 39.9655 139.2 39.8896 139.946 39.8896H141.738Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.848 43.3513C151.848 43.1237 151.791 42.9182 151.678 42.7348C151.564 42.5451 151.346 42.3744 151.023 42.2227C150.707 42.0709 150.239 41.9318 149.62 41.8054C149.076 41.6852 148.576 41.543 148.121 41.3786C147.672 41.2079 147.286 41.0024 146.964 40.7621C146.642 40.5219 146.392 40.2374 146.215 39.9086C146.038 39.5798 145.949 39.2004 145.949 38.7705C145.949 38.3532 146.041 37.958 146.224 37.585C146.408 37.212 146.67 36.8832 147.011 36.5987C147.353 36.3141 147.767 36.0897 148.254 35.9253C148.747 35.7609 149.297 35.6787 149.904 35.6787C150.764 35.6787 151.501 35.8241 152.114 36.115C152.733 36.3995 153.208 36.7883 153.536 37.2815C153.865 37.7683 154.03 38.3184 154.03 38.9317H151.744C151.744 38.6598 151.674 38.4069 151.535 38.173C151.403 37.9327 151.2 37.7399 150.928 37.5945C150.656 37.4427 150.315 37.3669 149.904 37.3669C149.512 37.3669 149.186 37.4301 148.927 37.5565C148.674 37.6767 148.485 37.8347 148.358 38.0307C148.238 38.2267 148.178 38.4417 148.178 38.6757C148.178 38.8464 148.21 39.0013 148.273 39.1404C148.342 39.2731 148.456 39.3964 148.614 39.5102C148.772 39.6177 148.987 39.7189 149.259 39.8137C149.537 39.9086 149.885 40.0003 150.302 40.0888C151.086 40.2532 151.76 40.465 152.322 40.7242C152.892 40.9771 153.328 41.3059 153.631 41.7105C153.935 42.1089 154.087 42.6147 154.087 43.228C154.087 43.6832 153.989 44.1005 153.793 44.4799C153.603 44.8529 153.325 45.1785 152.958 45.4567C152.591 45.7286 152.152 45.9404 151.64 46.0921C151.134 46.2439 150.565 46.3198 149.933 46.3198C149.003 46.3198 148.216 46.1554 147.571 45.8266C146.926 45.4915 146.436 45.0647 146.101 44.5463C145.772 44.0215 145.608 43.4777 145.608 42.915H147.818C147.843 43.3386 147.96 43.6769 148.168 43.9298C148.383 44.1764 148.649 44.3566 148.965 44.4704C149.288 44.5779 149.62 44.6316 149.961 44.6316C150.372 44.6316 150.717 44.5779 150.995 44.4704C151.273 44.3566 151.485 44.2048 151.63 44.0152C151.776 43.8191 151.848 43.5979 151.848 43.3513Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.24 43.6726C172.24 43.445 172.183 43.2395 172.07 43.0561C171.956 42.8664 171.738 42.6957 171.415 42.544C171.099 42.3922 170.631 42.2531 170.012 42.1267C169.468 42.0065 168.968 41.8643 168.513 41.6999C168.064 41.5292 167.678 41.3237 167.356 41.0834C167.034 40.8432 166.784 40.5587 166.607 40.2299C166.43 39.9011 166.341 39.5217 166.341 39.0918C166.341 38.6745 166.433 38.2793 166.616 37.9063C166.8 37.5333 167.062 37.2045 167.403 36.92C167.745 36.6354 168.159 36.411 168.646 36.2466C169.139 36.0822 169.689 36 170.296 36C171.156 36 171.893 36.1454 172.506 36.4363C173.125 36.7208 173.6 37.1096 173.928 37.6028C174.257 38.0896 174.422 38.6397 174.422 39.253H172.136C172.136 38.9811 172.066 38.7282 171.927 38.4943C171.795 38.254 171.592 38.0612 171.32 37.9158C171.048 37.764 170.707 37.6882 170.296 37.6882C169.904 37.6882 169.578 37.7514 169.319 37.8778C169.066 37.998 168.877 38.156 168.75 38.352C168.63 38.548 168.57 38.763 168.57 38.997C168.57 39.1677 168.602 39.3226 168.665 39.4617C168.734 39.5944 168.848 39.7177 169.006 39.8315C169.164 39.939 169.379 40.0402 169.651 40.135C169.929 40.2299 170.277 40.3216 170.694 40.4101C171.478 40.5745 172.152 40.7863 172.714 41.0455C173.284 41.2984 173.72 41.6272 174.023 42.0318C174.327 42.4302 174.479 42.936 174.479 43.5493C174.479 44.0045 174.381 44.4218 174.185 44.8012C173.995 45.1742 173.717 45.4998 173.35 45.778C172.983 46.0499 172.544 46.2617 172.032 46.4134C171.526 46.5652 170.957 46.6411 170.325 46.6411C169.395 46.6411 168.608 46.4767 167.963 46.1479C167.318 45.8128 166.828 45.386 166.493 44.8676C166.164 44.3428 166 43.799 166 43.2363H168.21C168.235 43.6599 168.352 43.9982 168.56 44.2511C168.775 44.4977 169.041 44.6779 169.357 44.7917C169.68 44.8992 170.012 44.9529 170.353 44.9529C170.764 44.9529 171.109 44.8992 171.387 44.7917C171.665 44.6779 171.877 44.5261 172.022 44.3365C172.168 44.1404 172.24 43.9192 172.24 43.6726Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.392 31.5625V46.13H156.097V31.5625H158.392ZM164.766 35.8683L160.299 40.8189L157.852 43.3227L157.254 41.388L159.104 39.1023L162.006 35.8683H164.766ZM162.499 46.13L159.17 41.3121L160.612 39.7093L165.145 46.13H162.499Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1660_87",
    x1: 191.548,
    y1: 296.601,
    x2: 140.126,
    y2: 280.316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00670616,
    stopColor: "#FEF3ED",
    stopOpacity: 0.2178
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0389905,
    stopColor: "#F7CCB7",
    stopOpacity: 0.3035
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0718789,
    stopColor: "#F2AB8D",
    stopOpacity: 0.3908
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1048,
    stopColor: "#EE9270",
    stopOpacity: 0.4781
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1377,
    stopColor: "#EB805C",
    stopOpacity: 0.5655
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1707,
    stopColor: "#EA724D",
    stopOpacity: 0.6531
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2039,
    stopColor: "#E86944",
    stopOpacity: 0.7411
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2374,
    stopColor: "#E86641",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#E86641",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E86641",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E86641",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E86641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1660_87",
    x1: 152.653,
    y1: 271.743,
    x2: 192.503,
    y2: 271.743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40719D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1660_87",
    x1: 181.285,
    y1: 270.9,
    x2: 190.801,
    y2: 270.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40719D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1660_87",
    x1: 168.064,
    y1: 273.145,
    x2: 170.933,
    y2: 273.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40719D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1660_87",
    x1: 186.406,
    y1: 257.791,
    x2: 189.41,
    y2: 257.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40719D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1660_87",
    x1: 165.465,
    y1: 297.789,
    x2: 131.203,
    y2: 292.467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00670616,
    stopColor: "#FEF3ED",
    stopOpacity: 0.2178
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0389905,
    stopColor: "#F7CCB7",
    stopOpacity: 0.3035
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0718789,
    stopColor: "#F2AB8D",
    stopOpacity: 0.3908
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1048,
    stopColor: "#EE9270",
    stopOpacity: 0.4781
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1377,
    stopColor: "#EB805C",
    stopOpacity: 0.5655
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1707,
    stopColor: "#EA724D",
    stopOpacity: 0.6531
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2039,
    stopColor: "#E86944",
    stopOpacity: 0.7411
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2374,
    stopColor: "#E86641",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#E86641",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E86641",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E86641",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E86641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1660_87",
    x1: 146.216,
    y1: 266.289,
    x2: 159.333,
    y2: 266.289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40719D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1660_87",
    x1: 158.728,
    y1: 258.105,
    x2: 166.048,
    y2: 258.105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40719D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1660_87",
    x1: 148.745,
    y1: 268.986,
    x2: 153.657,
    y2: 268.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40719D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1660_87",
    x1: 152.986,
    y1: 247.162,
    x2: 157.442,
    y2: 247.162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40719D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1660_87",
    x1: 43.6471,
    y1: 228.233,
    x2: 115.932,
    y2: 228.233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40719D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1660_87",
    x1: 166.559,
    y1: 113.444,
    x2: 215.266,
    y2: 113.444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40719D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1660_87",
    x1: 158.426,
    y1: 213.389,
    x2: 225.108,
    y2: 213.389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40719D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1660_87",
    x1: 248.987,
    y1: 88.1923,
    x2: 255.866,
    y2: 88.1923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40719D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1660_87",
    x1: 26.1434,
    y1: 141.03,
    x2: 52.5604,
    y2: 141.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40719D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1660_87",
    x1: 43.1764,
    y1: 249.884,
    x2: 115.462,
    y2: 249.884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40719D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1660_87",
    x1: 157.157,
    y1: 242.648,
    x2: 223.839,
    y2: 242.648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40719D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1660_87",
    x1: 248.515,
    y1: 109.843,
    x2: 255.395,
    y2: 109.843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40719D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1660_87",
    x1: 25.6727,
    y1: 162.679,
    x2: 52.0897,
    y2: 162.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40719D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1660_87",
    x1: 239.702,
    y1: 94.9327,
    x2: 230.933,
    y2: 92.0713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00670616,
    stopColor: "#FEF3ED",
    stopOpacity: 0.2178
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0389905,
    stopColor: "#F7CCB7",
    stopOpacity: 0.3035
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0718789,
    stopColor: "#F2AB8D",
    stopOpacity: 0.3908
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1048,
    stopColor: "#EE9270",
    stopOpacity: 0.4781
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1377,
    stopColor: "#EB805C",
    stopOpacity: 0.5655
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1707,
    stopColor: "#EA724D",
    stopOpacity: 0.6531
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2039,
    stopColor: "#E86944",
    stopOpacity: 0.7411
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2374,
    stopColor: "#E86641",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#E86641",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E86641",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E86641",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E86641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1660_87",
    x1: 60.0046,
    y1: 221.034,
    x2: 51.2354,
    y2: 218.173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00670616,
    stopColor: "#FEF3ED",
    stopOpacity: 0.2178
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0389905,
    stopColor: "#F7CCB7",
    stopOpacity: 0.3035
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0718789,
    stopColor: "#F2AB8D",
    stopOpacity: 0.3908
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1048,
    stopColor: "#EE9270",
    stopOpacity: 0.4781
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1377,
    stopColor: "#EB805C",
    stopOpacity: 0.5655
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1707,
    stopColor: "#EA724D",
    stopOpacity: 0.6531
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2039,
    stopColor: "#E86944",
    stopOpacity: 0.7411
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2374,
    stopColor: "#E86641",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#E86641",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E86641",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E86641",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E86641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1660_87",
    x1: 58.1914,
    y1: 45.9318,
    x2: 205.035,
    y2: 45.9318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40719D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1660_87",
    x1: 59.2202,
    y1: 182.365,
    x2: 67.0614,
    y2: 182.365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40719D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1660_87"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 261,
    height: 296,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoTasksFound);
export default __webpack_public_path__ + "static/media/no-tasks-found.07d041539579e2bf57c005ca95843f71.svg";
export { ForwardRef as ReactComponent };